<script setup>
import { useI18n } from "vue-i18n";
import { FormCard, FormInput } from "@Components/Form";
import Timepicker from "@Components/Form/Timepicker.vue";
import LanguageMenu from "@Components/LanguageMenu.vue";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronUpIcon } from "lucide-vue-next";

const props = defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <FormCard>
        <Disclosure as="div" v-slot="{ open }" :defaultOpen="true">
            <DisclosureButton
                :class="[
                    open ? 'rounded-t-lg' : 'rounded-lg',
                    'w-full flex justify-between px-6 py-3 text-sm font-medium text-left text-gray-900 border border-gray-300 dark:text-white dark:border-gray-800 focus:outline-none focus-visible:ring-gray-500/75 focus-visible:ring hover:bg-gray-50 dark:hover:bg-gray-900',
                ]">
                <span>{{ modelValue.type === "rss" ? __("Flux RSS") : __("GNews") }}</span>
                <ChevronUpIcon :class="open ? 'rotate-180 transform' : ''" class="w-5 h-5 text-gray-900 dark:text-white" />
            </DisclosureButton>
            <DisclosurePanel as="div" class="px-6 py-6 space-y-6 rounded-b-lg border-r border-b border-l border-gray-300 dark:border-gray-800">
                <FormInput
                    v-if="modelValue.type === 'rss'"
                    v-model="modelValue.modules.autopilot.query"
                    :label="__('Saisissez le lien d\'un flux RSS')"
                    placeholder="https://example.com/feed" />
                <FormInput
                    v-else-if="modelValue.type === 'news'"
                    v-model="modelValue.modules.autopilot.query"
                    :label="__('Générer du contenu d\'actualité sur le mot clé suivant')" />
                <div class="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                    <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Publier automatiquement") }}</div>
                    <div class="w-20">
                        <FormInput type="number" min="1" v-model.number="modelValue.modules.autopilot.planning.per_day" />
                    </div>
                    <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("publications par jour entre") }}</div>
                    <div class="w-24">
                        <Timepicker v-model="modelValue.modules.autopilot.planning.start_time" />
                    </div>
                    <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("et") }}</div>
                    <div class="w-24">
                        <Timepicker v-model="modelValue.modules.autopilot.planning.end_time" />
                    </div>

                    <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("(UTC)") }}</div>
                </div>

                <div v-if="modelValue.type === 'news'">
                    <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Source des publications") }}</div>
                    <div class="w-48 mt-2">
                        <LanguageMenu v-model="modelValue.modules.autopilot.source_language" />
                    </div>
                </div>
            </DisclosurePanel>
        </Disclosure>
    </FormCard>
</template>
